import React from 'react';
import { ExternalCustomerAddressType } from 'models/customer_profile/external_customer_address';
import ContactTwitterIcon from 'components/lib/icons/contact_twitter_icon';
import { faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ExternalCustomerAddressField = props => {
  if (!props.address) {
    return null;
  }

  switch (props.address.type) {
    case ExternalCustomerAddressType.INSTAGRAM_DIRECT:
      if (!props.isInstagramEnabled) {
        return null;
      }
      return renderInstagramDirectField(props.address.displayName);
    case ExternalCustomerAddressType.TWITTER:
      if (!props.isTwitterEnabled) {
        return null;
      }
      return renderTwitterField(props.address.displayName);
    case ExternalCustomerAddressType.WHATSAPP:
      if (!props.isWhatsAppEnabled) {
        return null;
      }
      return renderWhatsAppField(props.address.displayName);
    default:
      return null;
  }
};

function renderInstagramDirectField(displayName) {
  return (
    <div className="customerProfile-instagramRow customerProfile-contactDetails-row customerProfile-contactDetails-readonly">
      <FontAwesomeIcon icon={faInstagram} className="customerProfile-instagramIcon" />
      <div className="customerProfile-instagram-field">{displayName}</div>
    </div>
  );
}

function renderWhatsAppField(displayName) {
  return (
    <div className="customerProfile-whatsAppRow customerProfile-contactDetails-row customerProfile-contactDetails-readonly">
      <FontAwesomeIcon icon={faWhatsapp} className="customerProfile-whatsAppIcon" />
      <div className="customerProfile-whatsApp-field">{displayName}</div>
    </div>
  );
}

function renderTwitterField(displayName) {
  return (
    <div className="customerProfile-twitterRow customerProfile-contactDetails-row customerProfile-contactDetails-readonly">
      <ContactTwitterIcon className="customerProfile-twitterIcon" />
      <div className="customerProfile-twitter-field">{displayName}</div>
    </div>
  );
}
export default ExternalCustomerAddressField;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/profile/external_customer_address_field.jsx